module.exports = __webpack_public_path__ + "img/builder-8.654b7534.jpg";